// extracted by mini-css-extract-plugin
export default {"MainContainer":"App_MainContainer__q9WSj"};